module.exports = __webpack_public_path__ + "static/media/DwarfINC.b24a02e0.jpg";